import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xedx5mreu: FaireProductEntity = {
  token: "p_5xedx5mreu",
  type: "product",
  name: "3MM Smooth 18K Gold-plated Stainless Steel Bangle - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/20f3864a96789fd1e619ecb609738478f4adf0348e158be597cc667c8f049ba7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4abe0b81ee82bbf7e4290df393111ebf624069338d68366788f20e5fe779f289.jpeg",
    "https://cdn.faire.com/fastly/8ec1606524a18e46edbb11b3b69f8a04265c467072f361bded14d2cd5a45c772.jpeg",
    "https://cdn.faire.com/fastly/79d9206252d2886ddf94b15aca3f2625ec12d5b85376d416411026a6a473463d.jpeg",
    "https://cdn.faire.com/fastly/20698dc04ace953a2f5180a0fa29e8942d37b2e4ada36d693883a3a45765665c.jpeg",
  ],
  priceDollars: 3.92,
  description:
    "\nThe customer can choose to purchase multiple bracelets for a stacked look, which would enhance the overall appearance. \n\nWe recommend stacking 5-10 bracelets for a more stylish and coordinated ensemble.\n\nType: Bangle bracelet\nMaterial: Stainless steel,18K gold plated\nSize ：width - 3mm，Inner diameter 62mm\n\nProcess: vacuum electroplating and manual polishingSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 10.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:46.769Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
